import LineDetail from "./LineDetail";

export default LineDetail;
